/**
 * ¿EN QUÉ IDIOMA LEE ESTE CLIENTE?
 *
 * ── EL FALLO QUE ARREGLA ────────────────────────────────────────────────────
 *
 * Lissette, 2026-09-01 (punto 1 de 9): *"no importa el idioma del cliente, los
 * correos de firmas y solicitud de documentos van en inglés"*.
 *
 * Las dos pantallas arrancaban su selector de idioma con el idioma de la
 * PANTALLA DEL AGENTE:
 *
 *     const [formLang] = useState(lang === 'es' ? 'es' : 'en');   // DocRequests
 *     const [sendLang] = useState(lang);                          // Firmas
 *
 * Y ese valor viaja al servidor como una elección explícita, que allí GANA
 * sobre el `preferredLanguage` del cliente. O sea: el cliente tenía el campo
 * bien puesto y no servía de nada.
 *
 * Está mal en las dos direcciones, no solo hacia el inglés: una agente que
 * trabaja en español le escribía en español a un cliente que pidió inglés. Solo
 * parecía correcto cuando agente y cliente hablaban el mismo idioma — que es lo
 * que hace que un fallo así sobreviva meses.
 *
 * ── LA REGLA ───────────────────────────────────────────────────────────────
 *
 * Lo que lee el CLIENTE va en el idioma del CLIENTE. Lo que lee la AGENTE va en
 * el suyo. Son dos preguntas distintas y hasta ahora se contestaban con el
 * mismo dato.
 *
 * El agente sigue pudiendo cambiarlo a mano: el selector ES/EN de los dos
 * modales no se toca. Esto solo decide con qué idioma ABRE, que es lo que se
 * usa el 99 % de las veces.
 *
 * ── POR QUÉ HACE FALTA UNA FUNCIÓN Y NO LEER EL CAMPO ──────────────────────
 *
 * Un cliente llega con DOS formas del mismo dato, según por dónde entró
 * (`api.js` líneas 87-92):
 *
 *     preferredLanguage: 'es' | 'en'          ← la del backend
 *     preferredLang:     'spanish' | 'english' ← la que usa el formulario viejo
 *
 * Cada pantalla que lo lea a mano acabará mirando solo una y acertando a
 * medias. Es exactamente el E-138: la misma idea con dos nombres se separa.
 *
 * Vive fuera de los componentes para poder ejecutarlo en las pruebas sin montar
 * React ni arrastrar MSAL.
 */

/**
 * El idioma en el que hay que escribirle a este cliente: 'es' o 'en'.
 *
 * Acepta las dos formas del campo. Si el cliente no dice nada —o no hay
 * cliente todavía, que pasa mientras se elige uno en el modal— cae al idioma
 * de quien está mirando: es la suposición menos mala, porque una agente que
 * trabaja en español suele tener clientela en español.
 */
export function idiomaDelCliente(client, idiomaDePantalla = 'en') {
  const crudo = String(
    client?.preferredLanguage || client?.preferredLang || '',
  ).trim().toLowerCase();
  // 'es', 'es-US', 'spanish', 'español'… todas son la misma respuesta.
  if (crudo.startsWith('es') || crudo.startsWith('spa')) return 'es';
  if (crudo.startsWith('en')) return 'en';
  return idiomaDePantalla === 'es' ? 'es' : 'en';
}
